<table
	mat-table
	[dataSource]="items"
	matSort
	class="w-full table-auto border-none"
	[trackBy]="trackByFn"
>
	<ng-container matColumnDef="title">
		<th class="text-base w-5/12" mat-header-cell *matHeaderCellDef>
			{{ title }} ({{ items?.length }})
		</th>
		<td mat-cell class="text-base" *matCellDef="let element">
			{{ element.accountingItem.title }}
		</td>

		<td
			class="font-bold border-t text-base"
			[ngClass]="{
				'align-bottom ': hst !== null,
				'align-middle': hst === null,
			}"
			mat-footer-cell
			*matFooterCellDef
		>
			Total
		</td>
	</ng-container>

	<ng-container matColumnDef="amount">
		<th
			mat-header-cell
			*matHeaderCellDef
			class="text-start text-base max-w-3/12"
		>
			Amount
		</th>
		<td mat-cell *matCellDef="let element" class="text-start text-base">
			{{ element.accountingItem.amount | centsToDollars }}
		</td>

		<td
			mat-footer-cell
			*matFooterCellDef
			class="text-start px-2 border-t text-base"
		></td>
	</ng-container>

	<ng-container matColumnDef="activityCode">
		<th
			mat-header-cell
			*matHeaderCellDef
			class="text-start text-base w-[400px] min-w-[400px]"
		>
			{{ activityCodeColumnTitle }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
			class="text-base text-center flex items-center justify-center p-2 box-content pr-4 w-[400px] min-w-[400px]"
		>
			<app-searchable-dropdown
				class="min-w-[400px]"
				[items]="activityCodesDropdownOptions"
				[ngModel]="element.accountingItem.activityCode"
				(ngModelChange)="onActivityCodeChange($event, element)"
				placeholder="Select a code"
				[submitted]="true"
			></app-searchable-dropdown>
		</td>

		<td
			mat-footer-cell
			*matFooterCellDef
			class="text-end px-2 border-t text-base"
			[ngClass]="{
				'align-bottom ': hst !== null,
				'align-middle': hst === null,
			}"
		>
			<p class="text-xs mb-2" *ngIf="hst !== null">
				+ HST ({{ hst | percent }}) {{ hstTotal | centsToDollars }}
			</p>
			<p class="font-bold text-base">{{ total + hstTotal | centsToDollars }}</p>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="displayedColumns"
		class="sticky top-0"
	></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	<tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>
